/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_error_loading_members = /** @type {(inputs: { message: NonNullable<unknown> }) => string} */ (i) => {
	return `Error al cargar miembros: ${i.message}`
};

const en_persons_error_loading_members = /** @type {(inputs: { message: NonNullable<unknown> }) => string} */ (i) => {
	return `Error loading members: ${i.message}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ message: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_error_loading_members = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_error_loading_members(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_error_loading_members", locale)
	if (locale === "es") return es_persons_error_loading_members(inputs)
	return en_persons_error_loading_members(inputs)
};
export { persons_error_loading_members as "persons.error_loading_members" }